import { AutocompleteInput, DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { UserCheck } from "lucide-react";
import {
  DateInput,
  DateTimeInput,
  Edit,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
} from "../common";

const statusChoices = [
  { id: "present", name: "Present" },
  { id: "absent", name: "Absent" },
  { id: "half_day", name: "Half Day" },
  { id: "leave", name: "Leave" },
  { id: "holiday", name: "Holiday" },
  { id: "weekoff", name: "Weekoff" },
];

const sourceChoices = [
  { id: "manual", name: "Manual" },
  { id: "biometric", name: "Biometric" },
  { id: "web", name: "Web" },
  { id: "auto", name: "Auto" },
];

const AttendanceEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Log" />
  </div>
);

export const AttendanceEdit = () => (
  <Edit title="Edit Attendance" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <UserCheck className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Attendance Record</h2>
      </div>
      <SimpleForm toolbar={<AttendanceEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReferenceInput source="employee_id" reference="employees">
            <AutocompleteInput label="Employee" optionText="name" />
          </ReferenceInput>
          <DateInput source="date" />
          <SelectInput source="status" choices={statusChoices} />
          <SelectInput source="source" choices={sourceChoices} />
          <DateTimeInput source="check_in" />
          <DateTimeInput source="check_out" />
          <NumberInput source="hours_worked" label="Hours Worked" />
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);

